import { render } from "./loader.vue?vue&type=template&id=04b9625c&scoped=true&ts=true"
import script from "./loader.vue?vue&type=script&lang=ts"
export * from "./loader.vue?vue&type=script&lang=ts"

import "./loader.vue?vue&type=style&index=0&id=04b9625c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b9625c"]])

export default __exports__